import { useState } from 'react';
import { Offcanvas } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import back from '../../../src/assets/img/leadsform/backbtn2.svg';

const RightOffcanvas = ({ show, handleClose, handleLogout, user }) => {
  const currentApplicationVersion = process.env.REACT_APP_VERSION;

  return (
    <Offcanvas show={show} onHide={handleClose} placement="end">
      <Offcanvas.Body>
        <div className="logout-content">
          <div className="user-detail">
            <img src="/assets/images/user.png" alt="" />
          </div>
          <Offcanvas.Header closeButton></Offcanvas.Header>
        </div>
        <div className="logout-settings">
          <h5>Settings</h5>
          <img src="/assets/images/settings.png" alt="settings" />
        </div>
        <div className="setting-links"></div>
        <div className="version">UI Version: {currentApplicationVersion}</div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

const HeaderCRM = ({ handleToggleMenu, toggleMenu }) => {
  const isActive = (path) => pathname === path;
  const pathname = useLocation().pathname;
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const AttendanceFlag = process.env.REACT_APP_ATTENDANCE_FLAG === "true";
  const [navLinks, setNavLinks] = useState([
    'Lead',
    'Contacts',
    'Accounts',
    'Opportunity',
    'Tickets',
    'Meetings',
  ]);
  const [activeLink, setActiveLink] = useState(navLinks[0]);

  const [moreLinks, setMoreLinks] = useState([
    'Calls',
    'Campaigns',
    'Services',
    'Projects',
    'Reports',
    'Analytics',
  ]);

  const handleNavClick = (link, index) => {
    setActiveLink(link.toLowerCase());
    let arr = navLinks;
    const value = arr.pop();
    arr.unshift(link);
    setNavLinks(arr);
    moreLinks.splice(index, 1);
    const updatedMoreLinks = [...moreLinks, value];
    setMoreLinks(updatedMoreLinks);
  };

  const [isSticky, setIsSticky] = useState(false);
  const [smallPadding, setSmallPadding] = useState(false);

  const formatBreadcrumb = (breadcrumb) => {
    return breadcrumb
      .replace(/([a-z])([A-Z])/g, '$1 $2') // Split camel case
      .toLowerCase() // Convert the entire string to lowercase
      .replace(/\b\w/g, (c) => c.toUpperCase()); // Capitalize each word
  };

  const pathSegments = pathname
    .split('/')
    .filter((segment) => segment) // Remove empty segments from leading/trailing slashes
    .map((segment) => formatBreadcrumb(segment)); // Format each segment

  console.log('test', pathSegments);

  // Generate full paths for linking
  const pathLinks = pathname
    .split('/')
    .filter((segment) => segment)
    .map((_, index, arr) => '/' + arr.slice(0, index + 1).join('/'));

  const nonLinkSegments = ['settings', 'products', 'sale'];

  const hasChild = pathSegments.length > 1;
  const navigate = useNavigate();
  const location = useLocation();
  const gotoAttendanceInfo = () => {
    navigate('/attendanceInfo');
  };
  const handleBack = () => {
    if (location.pathname === '/settings/templateGallery') {
      navigate('/settings/templates');
    } else if (location.pathname === '/leads/convertLead=Success') {
      navigate('/leads');
    } else if (location.pathname.includes('viewLead')) {
      navigate('/leads');
    } else if (location.pathname.includes('viewContact')) {
      navigate('/contacts');
    } else if (location.pathname.includes('viewAccount')) {
      navigate('/accounts');
    } else if (location.pathname.includes('viewOpportunity')) {
      navigate('/opportunity');
    } else if (location.pathname.includes('viewCampaign')) {
      navigate('/campaigns');
    } else {
      navigate(-1);
    }
  };
  const handleChangeDashboard = () => {
    if (location.pathname.includes('pnc')) {
      navigate('/dashboard');
    } else navigate('pncQuote/dashboard'); // e.g., "/dashboard" or "/products"
  };

  return (
    <>
      {pathname === '/leads/addLead/////////' ? (
        <div id="main_header">
          <div className="lead_hdbar">
            <div className="header-left">
              <div className="breadcrumb lft">
                <div>
                  <span title="Create Lead" className="curr">
                    Create Lead
                  </span>
                </div>
              </div>
            </div>
            <div className="header-right text-end">
              <div className="lead_end">
                <Link href="" className="cancel-lead ld-btn">
                  Cancel
                </Link>
                <Link href="" className="save-lead ld-btn">
                  Save
                </Link>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <>
          <div className="dsk">
            <div id="main_header">
              <div className="header-left">
                {hasChild && pathname !== '/dashboard' && (
                  <div className="backButton" onClick={handleBack}>
                    <img src={back} alt="backlogo" width="14px" style={{ marginRight: '.5rem' }} />
                  </div>
                )}
                <div className="breadcrumb lft">
                  <div>
                    <Link to="/dashboard" title="Home">
                      Home
                    </Link>

                    {pathSegments.length > 0 && <span className="hs"> / </span>}

                    {pathSegments.map((segment, index) => {
                      const excluded = ['settings', 'products', 'sales'];
                      const isLast = index === pathSegments.length - 1;
                      const isExcluded = excluded.includes(segment.toLowerCase());

                      return (
                        <span key={index}>
                          {!isLast ? (
                            <>
                              {isExcluded ? (
                                <span style={{ color: "#707070" }}>{segment}</span> // plain text
                              ) : (
                                <Link to={pathLinks[index]}>{segment}</Link>
                              )}
                              <span className="hs"> / </span>
                            </>
                          ) : (
                            <span className="curr">{segment}</span> // current page
                          )}
                        </span>
                      );
                    })}
                  </div>
                </div>
              </div>
              <div className="header-right text-end">
                <div className="button_align">
                  {location.pathname.includes('/dashboard') && (
                    <div className="dropdown" id="timelogdropdown">
                      <button
                        type="button"
                        className="plus_btn dropdown-toggle"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        {location.pathname.includes('pnc') ? 'P&C Dashboard' : 'Standard Dashboard'}
                      </button>


                      <ul className="dropdown-menu dropdown-menu-end">
                        {location.pathname.includes('pnc') ? (
                          <li className="dropdown-item">
                            <Link to="/dashboard">Standard Dashboard</Link>
                          </li>
                        ) : (
                          <li className="dropdown-item">
                            <Link to="pncQuote/dashboard">P & C Dashboard</Link>
                          </li>
                        )}
                      </ul>

                    </div>
                  )}
                  {AttendanceFlag ? (
                    <div>
                      <button
                        type="button"
                        className="btn btn-danger w-100"
                        aria-expanded="false"
                        onClick={gotoAttendanceInfo}
                        style={{ lineHeight: 1.0 }}
                      >
                        Attendance Info
                      </button>
                    </div>
                  ) : null}

                  <div className="add_plus crmdropdown">
                    <div className="dropdown">
                      <button
                        className="plus_btn"
                        type="button"
                        id="dropdownMenuButton"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16px"
                          height="16px"
                          viewBox="0 0 22 22"
                        >
                          <g
                            id="Edit_Add_Plus"
                            data-name="Edit / Add_Plus"
                            transform="translate(5 5)"
                          >
                            <path
                              id="Vector"
                              d="M6,10.8h4.8m0,0h4.8m-4.8,0v4.8m0-4.8V6"
                              transform="translate(-5.047 -5.047)"
                              fill="none"
                              stroke="#fff"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="1"
                            />
                            <g
                              id="Ellipse_50"
                              data-name="Ellipse 50"
                              transform="translate(-5 -5)"
                              fill="none"
                              stroke="#fff"
                              strokeWidth="1"
                            >
                              <circle cx="11" cy="11" r="11" stroke="none" />
                              <circle cx="11" cy="11" r="10.5" fill="none" />
                            </g>
                          </g>
                        </svg>
                      </button>

                      <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                        <li>
                          <Link className="dropdown-item" to={`/leads/CreateNew`}>
                            Add Lead
                          </Link>
                        </li>
                        <li>
                          <Link className="dropdown-item" to={`/contacts/addContact`}>
                            Add Contact
                          </Link>
                        </li>
                        <li>
                          <Link className="dropdown-item" to={`/accounts/addAccount`}>
                            Add Account
                          </Link>
                        </li>
                        <li>
                          <Link className="dropdown-item" to={`/opportunity/addOpportunity`}>
                            Add Opportunity
                          </Link>
                        </li>
                        <li>
                          <Link className="dropdown-item" to={`/campaigns/addCampaign`}>
                            Add Campaign
                          </Link>
                        </li>
                        <li>
                          <Link className="dropdown-item" to={`/tickets/addTicket`}>
                            Add Ticket
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="mob">
            <div id="main_header-mob" style={{ marginLeft: toggleMenu ? '72px' : '0px' }}>
              <div className="main_hdr_top">
                <div className="toggleMenu" onClick={handleToggleMenu}>
                  <i className="bi bi-list"></i> <span>Menu</span>
                </div>

                <div className="add_plus crmdropdown">
                  <div className="dropdown">
                    <button
                      className="plus_btn"
                      type="button"
                      id="dropdownMenuButton"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16px"
                        height="16px"
                        viewBox="0 0 22 22"
                      >
                        <g
                          id="Edit_Add_Plus"
                          data-name="Edit / Add_Plus"
                          transform="translate(5 5)"
                        >
                          <path
                            id="Vector"
                            d="M6,10.8h4.8m0,0h4.8m-4.8,0v4.8m0-4.8V6"
                            transform="translate(-5.047 -5.047)"
                            fill="none"
                            stroke="#fff"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1"
                          />
                          <g
                            id="Ellipse_50"
                            data-name="Ellipse 50"
                            transform="translate(-5 -5)"
                            fill="none"
                            stroke="#fff"
                            strokeWidth="1"
                          >
                            <circle cx="11" cy="11" r="11" stroke="none" />
                            <circle cx="11" cy="11" r="10.5" fill="none" />
                          </g>
                        </g>
                      </svg>
                    </button>

                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                      <li>
                        <Link className="dropdown-item" to={`/leads/CreateNew`}>
                          Add Lead
                        </Link>
                      </li>
                      <li>
                        <Link className="dropdown-item" to={`/contacts/addContact`}>
                          Add Contact
                        </Link>
                      </li>
                      <li>
                        <Link className="dropdown-item" to={`/accounts/addAccount`}>
                          Add Account
                        </Link>
                      </li>
                      <li>
                        <Link className="dropdown-item" to={`/opportunity/addOpportunity`}>
                          Add Opportunity
                        </Link>
                      </li>
                      <li>
                        <Link className="dropdown-item" to={`/campaigns/addCampaign`}>
                          Add Campaign
                        </Link>
                      </li>
                      <li>
                        <Link className="dropdown-item" to={`/tickets/addTicket`}>
                          Add Ticket
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="header-left">
                {hasChild && pathname !== '/dashboard' && (
                  <div className="backButton" onClick={handleBack}>
                    <img src={back} alt="backlogo" width="14px" style={{ marginRight: '.5rem' }} />
                  </div>
                )}
                <div className="breadcrumb lft">
                  <div>
                    <Link to="/dashboard" title="Home">
                      Home
                    </Link>{' '}
                    {pathname === '/dashboard' ? (
                      <></>
                    ) : (
                      <span title="Client" className="curr">
                        {pathSegments}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default HeaderCRM;
